import React from "react";

const Row = ({ children, gap }) => {
  const gapClass = gap ? `gutter--${gap}` : 8;
  return <div className={`row__area ${gapClass}`}>{children}</div>;
};

export default Row;
